import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import styles from './SlotsUserStatusBadge.module.scss';

interface IAdminCancelledBy {
  id: number;
  name: string;
}

interface ISlotsUserStatusBadgeProps {
  status: { id: number; name: string; type: string };
  adminCancelledBy?: IAdminCancelledBy | null;
}

const SlotsUserStatusBadge = ({
  status,
  adminCancelledBy,
}: ISlotsUserStatusBadgeProps) => {
  const { t } = useTranslation();

  if (status.type === 'active') {
    return (
      <div
        className={cn(styles.slotsStatusBadge, styles.slotsStatusBadgeActive)}
      >
        {status.name}
      </div>
    );
  }
  if (
    status.type === 'canceled_by_user' ||
    status.type === 'canceled_by_admin'
  ) {
    return (
      <div className={styles.statusWrapper}>
        <div
          className={cn(
            styles.slotsStatusBadge,
            styles.slotsStatusBadgeInactive
          )}
        >
          {status.name}
        </div>
        {status.type === 'canceled_by_admin' && adminCancelledBy && (
          <>
            <span>/</span>
            <Link
              to={`/user/${adminCancelledBy.id}`}
              className={styles.contactLink}
            >
              {t('to_contact')}
            </Link>
          </>
        )}
      </div>
    );
  }
  if (status.type === 'completed') {
    return (
      <div
        className={cn(
          styles.slotsStatusBadge,
          styles.slotsStatusBadgeCompleted
        )}
      >
        {status.name}
      </div>
    );
  }
};

export default SlotsUserStatusBadge;
